export const ADDRESS_FIELD_MAX_LENGTHS = Object.freeze({
  addressLine1: 300,
  addressLine2: 300,
  phoneNumber: 40,
  firstName: 100,
  lastName: 100,
  city: 75,
})

export const ADDRESS_FIELD_MAX_LENGTHS_BY_KEY = Object.freeze({
  ...ADDRESS_FIELD_MAX_LENGTHS,
  address1: ADDRESS_FIELD_MAX_LENGTHS.addressLine1,
  address2: ADDRESS_FIELD_MAX_LENGTHS.addressLine2,
  phone: ADDRESS_FIELD_MAX_LENGTHS.phoneNumber,
  first_name: ADDRESS_FIELD_MAX_LENGTHS.firstName,
  last_name: ADDRESS_FIELD_MAX_LENGTHS.lastName,
})

export type AddressFieldKey = keyof typeof ADDRESS_FIELD_MAX_LENGTHS_BY_KEY
